<script setup lang="ts">

const model = defineModel<number>( { required: true });
const { count, size = 'md' } = defineProps<{ count: number, size: 'sm' | 'md' | 'lg' }>();

const dotSizes: Record<string,string> = { sm: 'w-2 h-2', md: 'w-2.5 h-2.5', lg: 'w-3 h-3' };
const dotSize = dotSizes[ size ];

</script>

<template>
    <div class="w-full flex items-center justify-center gap-x-3">
        <a v-for="index in count"
             class="rounded-full cursor-pointer
                    bg-black/10 dark:bg-white/10
                    hover:bg-black/25 dark:hover:bg-white/25
                    hover:ring-4 ring-black/5 dark:ring-white/5"
             :class="[{ '!bg-black/50 dark:!bg-white/50 pointer-events-none': index == model + 1 }, dotSize ]"
             @click="() => model = index - 1">
        </a>
    </div>
</template>